<template>
  <div class="widget release">
    <div class="widget-heading flex-column">
      <h2 class="mb-1 textStyle">{{ note.name }}</h2>
      <div class="date-badge-container fst-italic">
        <span class="badge">{{ note.tag }}</span>
        <span class="note-date fst-italic ms-1">- {{ dateFormatter().format(note.publicationDate, "short") }}</span>
      </div>
    </div>
    <div class="widget-content">
      <div>
        <p class="sub-title intro">{{ note.subTitle }}</p>
      </div>
      <p class="description" v-html="processContent(note.textContent)"></p>
    </div>
  </div>
</template>

<script>
import { dateFormatter } from "@/services/utilities/date-formatter";
import { stringManager } from "@/services/utilities/string-manager";

export default {
  name: "ReleaseNotesItemBlockComponent",
  methods: {
    dateFormatter() {
      return dateFormatter;
    },

    processContent(text) {
      return stringManager.processGlobalContent(text);
    },
  },
  props: {
    note: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.date-badge-container {
  display: flex;
  align-items: center;
}

.note-date {
  color: #6c757d;
  font-size: 0.9rem;
}

.switch-roww {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: -10px;
}

.widget-headingg {
  padding: 10px;
  display: flex;
  border-bottom: 1px dashed #e0e6ed;
  transition: all 300ms ease-in-out;

  @include up-to-lg {
    padding: 10px 20px;
  }
}

.release {
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  align-self: center;
}

.badge {
  background: var(--secondary-color);
}
</style>
